(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Function to clone promo content to header-promo-place elements
  function clonePromoContent() {
    setTimeout(() => {
      const promoElements = document.querySelectorAll('[id^="promo-"]');
      promoElements.forEach((promoElement) => {
        const promoId = promoElement.id;
        const promoText = promoId.replace('promo-', '');
        const targetElement = document.querySelectorAll(`.header-promo-place-${promoText}`);
        if (targetElement.length > 0) {
          targetElement.forEach((targetEl) => {
            targetEl.innerHTML = promoElement.innerHTML;
          })
        }
      });
    }, 2000);
  }

  document.addEventListener('DOMContentLoaded', clonePromoContent);
  } catch(e) { console.error(e); }
})();

})();
